/**
 * Valida que un número sea un porcentaje entre 0 y 100 con hasta 2 decimales
 */
export function validatePercentage(value: number): boolean {
  if (isNaN(value) || value < 0 || value > 100) return false
  return /^(\d+(\.\d{1,2})?)$/.test(value.toString())
}
